var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { r as registerInstance, h, H as Host, g as getElement } from './core-6f498fd9.js';
import './auto-close-handler-253c0ad4.js';
import { P as Position, U as UuidService, a as PositionHandler } from './position-handler-48f35349.js';
var CsmTooltip = /** @class */ (function () {
    function class_1(hostRef) {
        registerInstance(this, hostRef);
        this.position = Position.TOP;
        this.boxContainer = window;
        this.delay = 200;
        this.tooltipId = UuidService.v4();
    }
    class_1.prototype.getTooltipId = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.tooltipId];
            });
        });
    };
    class_1.prototype.getTooltipRef = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_b) {
                return [2 /*return*/, this.contentRef];
            });
        });
    };
    class_1.prototype.disconnectedCallback = function () {
        var _a;
        (_a = this.contentRef) === null || _a === void 0 ? void 0 : _a.remove();
    };
    class_1.prototype.componentDidLoad = function () {
        var _this = this;
        if (!this.parentReference) {
            this.parentReference = this.tooltip.parentElement;
        }
        this.parentReference.onmouseenter = function () {
            _this.renderTooltipContent();
            document.body.appendChild(_this.contentRef);
        };
        this.parentReference.onmouseleave = function () {
            var _a;
            (_a = _this.positionHandler) === null || _a === void 0 ? void 0 : _a.onMouseLeave();
            document.body.removeChild(_this.contentRef);
        };
    };
    class_1.prototype.componentDidUnload = function () {
        var _a;
        (_a = this.positionHandler) === null || _a === void 0 ? void 0 : _a.destroy();
    };
    class_1.prototype.renderTooltipContent = function () {
        var tooltipContentElement = document.createElement('csm-tooltip-content');
        tooltipContentElement.style.position = 'absolute';
        tooltipContentElement.style.width = '0';
        tooltipContentElement.style.height = '0';
        tooltipContentElement.className = this.tooltip.className;
        this.contentRef = tooltipContentElement;
        this.contentRef.setAttribute('tooltip-id', this.tooltipId);
        var childNodes = this.tooltip.childNodes;
        for (var i = 0; i < childNodes.length; i++) {
            this.contentRef.append(childNodes.item(i).cloneNode(true));
        }
    };
    class_1.prototype.onTooltipLoaded = function (event) {
        if (event.detail === this.tooltipId) {
            this.positionHandler = new PositionHandler(this.contentRef.querySelector('.csm-tooltip'), this.parentReference, this.boxContainer, this.position, this.delay);
            this.positionHandler.onMouseEnter();
        }
    };
    class_1.prototype.render = function () {
        return (h(Host, { "data-tooltip-id": this.tooltipId }, h("div", { class: "hidden" }, h("slot", null))));
    };
    Object.defineProperty(class_1.prototype, "tooltip", {
        get: function () { return getElement(this); },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(class_1, "style", {
        get: function () { return ".hidden{display:none}"; },
        enumerable: true,
        configurable: true
    });
    return class_1;
}());
export { CsmTooltip as csm_tooltip };
